export const agreementServiceExpirationDateField = {
  title: 'Service end date',
  humanReadableKey: 'Service end date',
  placeHolder: 'Service end date',
  id: 'subscriptionEndDate',
  isRequired: false,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
  minDate: 'today',
}
